import { Component, OnInit,ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { LoanschemeService } from "../shared/loanscheme.service";

@Component({
  selector: 'app-loanschemelist',
  templateUrl: './loanschemelist.component.html',
  styleUrls: ['./loanschemelist.component.css']
})

export class LoanschemelistComponent implements OnInit {

  displayedColumns: string[] = ['Name', 'Loan Type', 'Loan Category','Interest','Min. Loan Amount','Max. Loan Amount','Loan Payment Type', 'Active', 'New'];
  ChequeList$ = [''];
  dataSource = new MatTableDataSource<any>();
 @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(private router: Router, private loanschemeService: LoanschemeService) { 
  this.dataSource.paginator = this.paginator;
   }

  ngOnInit() { 
    this.getLoanschemeList();
  }

  getLoanschemeList() {
    this.loanschemeService.FetchLoanSchemeList().subscribe(data => {
      this.dataSource.data = data;
    })
  }

  public AddNew() {
    this.router.navigate(['/loanscheme']);
  }

  Edit(ledger: any) {
    this.router.navigate(['/loanscheme', ledger.Id]);
  }

}
